import { FunctionComponent } from "react";
import { useParams } from "react-router-dom";
import { ROUTE_DASHBOARD_GEAR_EDIT } from "../../../shared/app-constants";
import getDashboardRoute from "../../../shared/get-dashboard-route";
import GearDetail from "../../components/gear-detail";
import HttpClient from "../../http-client";

interface GearDetailPageProps {
  self?: boolean;
}

const GearDetailPage: FunctionComponent<GearDetailPageProps> = () => {
  const { id } = useParams();
  return (
    <GearDetail
      editPath={getDashboardRoute({ id } as any, ROUTE_DASHBOARD_GEAR_EDIT)}
      homepage={getDashboardRoute({})}
      httpClient={HttpClient}
      id={id!}
    />
  );
};

export default GearDetailPage;
